/* Returns a function that can substitute as a callback when you want
   triggers to the callback to be debounced.
 */
export function debouncer(callback, duration) {
  let timeout = null
  return callbackArg => {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      callback(callbackArg)
    }, duration)
  }
}
